// extracted by mini-css-extract-plugin
export default {"wrapper":"LocalizacaoPendenteAlert_wrapper__YikI3","botaoDefinir":"LocalizacaoPendenteAlert_botaoDefinir__ODOSf"};